/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "document-unread",

    getDefaultProps: function getDefaultProps() {
        return {
            "documentUnread": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "53.9",
            "height": "69"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53.9 69", className: "document-unread", width: this.props.width, height: this.props.height, style: this.props.documentUnread },
            _react2["default"].createElement(
                "g",
                { fill: "#367C2B" },
                _react2["default"].createElement("path", { d: "M14.2 30h26v4.9h-26zM14.2 46.2h26v4.9h-26z" }),
                _react2["default"].createElement("path", { d: "M41.3 0H0v69h53.9V12.6L41.3 0zm7.6 64.1H5V4.9h32v12.6h11.9v46.6z" })
            )
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/document-unread.js